<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCSpecs :h2="this.h2" :h3="this.h3" :specs="this.benefits" />
  </div>
</template>

<script>
import FCSpecs from "@/components/patterns/FCSpecs";
export default {
  components: {
    FCSpecs,
  },
  data() {
    return {
      h2: "The Bailey",
      h3: "Benefits",
      benefits: [
        {
          icon: "icon-fb.png",
          text: `Food & Beverage: A supporters bar located immediately behind The Bailey will offer a collection of supporter-centric beverages and portable food local to Cincinnati.`,
        },
        {
          icon: "icon-standing.png",
          text: `Standing Style: <strong>Safe-standing</strong> benches with railings for safety (+ cupholders!)`,
        },
      ],
    };
  },
  mounted() {
    const ref = this.$store.state.menu.bailey.ref;
    const index = this.$store.state.menu.menuItems
      .map((e) => e.ref)
      .indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.bailey.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.bailey.nav;
    this.onScroll();
  },
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-thebailey.jpg");
  background-size: cover;
  background-position: center;
}
</style>